const LOGO_STYLEU =
  "https://customer-assets.emergentagent.com/job_salon-simple-1/artifacts/khqw8d6p_WhatsApp%20Image%202026-04-21%20at%203.15.25%20PM.jpeg";
const LOGO_7HILLS =
  "https://customer-assets.emergentagent.com/job_salon-simple-1/artifacts/z11zpiql_WhatsApp%20Image%202026-04-21%20at%203.15.24%20PM.jpeg";

export default function BrandLogos({ variant = "navbar", className = "" }) {
  const size =
    variant === "navbar"
      ? "h-16 w-28 sm:h-20 sm:w-36"
      : "h-44 w-64 md:h-60 md:w-80";

  return (
    <div
      data-testid={`brand-logos-${variant}`}
      className={`flex items-center gap-3 sm:gap-5 ${className}`}
    >
      <img
        src={LOGO_STYLEU}
        alt="Style-U Hair Parlour"
        loading="lazy"
        className={`${size} object-contain brand-logo-styleu shrink-0`}
      />
      <img
        src={LOGO_7HILLS}
        alt="7 Hills Unisex Salon"
        loading="lazy"
        className={`${size} object-contain brand-logo-7hills shrink-0`}
      />
    </div>
  );
}
